export default {
  table: {
    annualEntitlement: "Annual Entitlement",
    additionalLeave: "Additional Leaves",
    consumed: "Consumed",
    currentBalToDate: "Current Balance to date",
    totalCurrentBal: "Total Current Balance",
    projectedBal: "Projected Balance"
  }
}